import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import DashboardPage from './pages/DashboardPage';
import PolicyTablePage from './pages/PolicyTablePage';
import AggregateDataPage from './pages/AggregateDataPage';
import PolicyDetailPage from './pages/PolicyDetailPage';
import { PoliciesProvider } from './context/PoliciesContext';
import './App.css';

function App() {
  return (
    <PoliciesProvider>
      <Router>
        <div className="min-h-screen bg-quickbooks-gray">
          <Header />
          <main className="container mx-auto px-4 py-8">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/policies" element={<PolicyTablePage />} />
              <Route path="/aggregate" element={<AggregateDataPage />} />
              <Route path="/policies/:policyNumber" element={<PolicyDetailPage />} />
            </Routes>
          </main>
        </div>
      </Router>
    </PoliciesProvider>
  );
}

export default App;
